import { render, staticRenderFns } from "./AssetType.vue?vue&type=template&id=1a10d718&scoped=true"
import script from "./AssetType.vue?vue&type=script&lang=js"
export * from "./AssetType.vue?vue&type=script&lang=js"
import style0 from "./AssetType.vue?vue&type=style&index=0&id=1a10d718&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a10d718",
  null
  
)

export default component.exports